import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-details-page-loader',
  templateUrl: './details-loader.component.html',
  styleUrls: [],
  standalone: false,
})
export class PageDetailsLoaderComponent implements OnInit {
  @Input() actionTypes: any;

  isLoading = false;
  constructor(
    private actions: Actions,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.actions
      .pipe(
        ofType(...this.actionTypes),
        tap(() => {
          setTimeout(() => {
            this.isLoading = false;
            this.cdr.detectChanges();
          });
        }),
      )
      .subscribe();
  }
}
